import {useEffect} from "react";
import { useSelector,useDispatch } from "react-redux"
import { verifyNewsRequest } from "features/VerifyNews/verifyNewsSlice";
 

const useVerifyNewsList = (start,limit) => {
   const dispatch = useDispatch();

   useEffect(()=>{
     dispatch(verifyNewsRequest([start,limit]));
   },[start,limit,dispatch]);

   return useSelector((state)=>{
     if(state.verifyNews.verifyNewsList) return state.verifyNews.verifyNewsList;
     return [];
   })
}

export default useVerifyNewsList;
